import { createSelector } from 'reselect';
import { uniq } from 'lodash';
import { metricSelector, selectedMetricSelector } from '@store/metricsChartContainer/selectors';
import trendsBaseSelector from '@store/trends/base/selectors';
import { summaryWidgetsSelector } from '@store/summaryWidgets/selector';
import { getFirstAppliedFilter, intervalSelector } from './selectors';
import { DIMENSION_MAP } from '@src/utils/constants';

export const dataToPersistSelector: any = createSelector(
  getFirstAppliedFilter,
  summaryWidgetsSelector,
  metricSelector,
  selectedMetricSelector,
  trendsBaseSelector,
  intervalSelector,
  (filter, summaryWidgets, chartMetrics, selectedMetric, trendsBase, interval) => {
    const { granularity = null } = interval;

    const { dimensions: dimensionKeys, globalOrderBy, dimensionMetrics } = trendsBase;
    return {
      filter,
      summaryWidgets,
      chartMetrics,
      selectedMetric,
      dimensionKeys,
      globalOrderBy,
      dimensionMetrics,
      granularity,
    };
  },
);

// map/filter persisted metrics to match supported metrics
// accepts array of metrics
// return empty array if there are no valid metrics
export function parseMetricsFn(supportedMetrics) {
  const metricSet = new Set(Object.keys(supportedMetrics));
  return (currentMetrics) => {
    // map name changes if any here

    // filter unsupported metrics
    const filteredMetrics = currentMetrics.filter((m) => metricSet.has(m));
    return uniq(filteredMetrics);
  };
}

/**
 * Below is a fix added for CE-10921, which was caused due to migration of LIVE_VIDEO and similar dimensions to tags
 * We ran a migration to update all the saved filters, however for the users who have persited filters for Content Category,
 * they will still have the old LIVE_VIDEO in filter bar, which will show error message since the dimension is on c3.video.isLive.
 * This is a temp fix and should be removed after a grace period of 3 months.
 * If someone hasn't opened the dashboard in 3 months, they will have to remove LIVE_VIDEO from the filter bar and add Content Category
 * https://conviva.atlassian.net/browse/CAS-736
 */
// TODO : remove below code as part of CAS-736 post April 2025

export function parseFilters(filters) {
  return filters.map((orRules) =>
    orRules.map((orRule) => {
      const replaceBackendRuleWithTag = orRule.field && orRule.field in DIMENSION_MAP;
      if (replaceBackendRuleWithTag) {
        orRule.key = DIMENSION_MAP[orRule.field];
        orRule.field = 'TAG';
      }
      return orRule;
    }),
  );
}

export default dataToPersistSelector;
